// extracted by mini-css-extract-plugin
module.exports = {"skeletonWrapper":"coqooHBm"};